export const HOME = {
  emergentLink: "emergent-link",
};

export const NAV = {
  logo: "nav-logo",
  homeLink: "nav-home-link",
  aboutLink: "nav-about-link",
  servicesLink: "nav-services-link",
  assessmentsLink: "nav-assessments-link",
  faqLink: "nav-faq-link",
  contactLink: "nav-contact-link",
  bookingBtn: "nav-booking-btn",
  mobileMenuBtn: "nav-mobile-menu-btn",
};

export const HERO = {
  section: "hero-section",
  headline: "hero-headline",
  subheadline: "hero-subheadline",
  primaryCta: "hero-primary-cta",
  secondaryCta: "hero-secondary-cta",
  heroImage: "hero-image",
};

export const ABOUT = {
  section: "about-section",
  philosophy: "about-philosophy",
  teamSection: "about-team-section",
};

export const SERVICES = {
  section: "services-section",
  childTherapyCard: "services-child-therapy-card",
  familyCounselingCard: "services-family-counseling-card",
  parentalSupportCard: "services-parental-support-card",
};

export const ASSESSMENTS = {
  section: "assessments-section",
  psychoeducationalCard: "assessments-psychoeducational-card",
  neurodevelopmentalCard: "assessments-neurodevelopmental-card",
  behavioralCard: "assessments-behavioral-card",
  timeline: "assessments-timeline",
};

export const FAQ = {
  section: "faq-section",
  accordion: "faq-accordion",
};

export const CONTACT = {
  section: "contact-section",
  address: "contact-address",
  hours: "contact-hours",
  phone: "contact-phone",
  email: "contact-email",
  bookingBtn: "contact-booking-btn",
  map: "contact-map",
};

export const FOOTER = {
  section: "footer-section",
  brand: "footer-brand",
  links: "footer-links",
};
